/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Word_LabelInputs */

const en_dialog_text_to_audio_word_label = /** @type {(inputs: Dialog_Text_To_Audio_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`word`)
};

const es_dialog_text_to_audio_word_label = /** @type {(inputs: Dialog_Text_To_Audio_Word_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palabra`)
};

/**
* | output |
* | --- |
* | "word" |
*
* @param {Dialog_Text_To_Audio_Word_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_word_label = /** @type {((inputs?: Dialog_Text_To_Audio_Word_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Word_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_word_label(inputs)
	return en_dialog_text_to_audio_word_label(inputs)
});